import styled from "styled-components";
import Button from "components/Button";

export const ActionButton = styled(Button)`
  width: 200px;
  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 100%;
  }
`;
